<template>
  <div class="container new-booking-container">
    <div class="filters-container">
      <div
        :class="`filter-pill ${!showDateFilter ? 'not-set' : ''}`"
        ref="dateDropdown"
      >
        <div :class="`datepickers ${!showDateFilter ? 'empty' : ''}`">
          <DateTimePickerResponsive
            ref="startDate"
            type="inline"
            v-model="startDate"
            hasClear
            :outputDate="dateFilterOutput"
            :disabledPreviousMonth="true"
            :disabledDates="handleDisabledDate"
            :dateOnly="true"
            :isClearable="true"
            :hasLabel="false"
            :markedDateToday="true"
            @onDateChange="handleDateChange"
            @apply="applyFilters"
            @clear="handleDateClear"
            @close="handleClose"
            @onToggle="closeDropdowns()"
          />
          <a
            class="icon-clear"
            v-if="showDateFilter && windowWidth >= 640"
            @click.stop="() => handleDateClear()"
          >
            <icon-base style="height: 1rem; width: 1rem; pointer-events: none;">
              <IconCancel />
            </icon-base>
          </a>
        </div>
      </div>
      <div
        :class="
          `filter-pill ${!categoryPicker && !selectedCategory ? 'not-set' : ''}`
        "
        ref="categoryDropdown"
      >
        <button
          @click="() => handlePickerToggle('category')"
          class="filter-button"
        >
          <span class="label">
            {{ selectedCategory ? selectedCategory.label : "Category" }}
          </span>
          <a
            v-if="selectedCategory && windowWidth >= 640"
            @click.stop="
              () => {
                selectedCategory = null;
                tempCategory = null;
                categoryPicker = false;
              }
            "
          >
            <icon-base style="height: 1rem; width: 1rem; pointer-events: none;">
              <IconCancel />
            </icon-base>
          </a>
        </button>
        <div
          class="pill-backdrop"
          v-if="windowWidth < 640 && categoryPicker"
        ></div>
        <transition name="fade-up">
          <div v-if="categoryPicker" class="pill-dropdown">
            <div class="pill-header" v-if="windowWidth < 640">
              <h5>Category</h5>
              <button class="dropdown-close" @click="closeDropdowns()">
                <img
                  class="icon-close"
                  src="@/assets/media/icons/icon-close-v2.svg"
                  alt="icon-close"
                />
              </button>
            </div>
            <div
              class="picker-container"
              v-on-clickaway="
                () => {
                  categoryPicker = false;
                }
              "
            >
              <ul class="picker-select--list">
                <li
                  v-for="(category, key) in categoryOptions"
                  :key="key"
                  :class="[
                    'picker-select--item',
                    {
                      active:
                        selectedCategory &&
                        selectedCategory.value === category.value,
                      disabled: !category.count
                    }
                  ]"
                  @click="
                    () => {
                      tempCategory = category;
                    }
                  "
                >
                  <label
                    class="css-control css-control-primary css-control-lg css-checkbox"
                  >
                    <template v-if="windowWidth < 640">
                      <input
                        type="radio"
                        class="css-control-input"
                        :class="
                          tempCategory && tempCategory.value === category.value
                            ? 'checked'
                            : ''
                        "
                        name="type"
                        :value="
                          tempCategory && tempCategory.value === category.value
                        "
                        checked
                      />
                      <span class="css-control-indicator"></span>
                    </template>
                    <span class="list-text">
                      {{ category.label }}
                      {{ category.count ? `(${category.count})` : "" }}
                    </span>
                  </label>
                </li>
              </ul>
              <div class="picker-action" v-if="windowWidth < 640">
                <ActionButton
                  class="btn-clear"
                  type="button"
                  :mode="'outline'"
                  :label="null"
                  :theme="buttonTheme"
                  :disabled="!this.tempCategory"
                  @customEvent="applySelected('category', true)"
                >
                  <p>Clear</p>
                </ActionButton>
                <ActionButton
                  class="btn-view"
                  type="button"
                  :label="null"
                  :theme="buttonTheme"
                  :disabled="isDisabledCategory"
                  @customEvent="applySelected('category')"
                >
                  <p>
                    View
                    {{ tempCategory ? `${tempCategory.count}` : "" }} workspaces
                  </p>
                </ActionButton>
              </div>
            </div>
          </div>
        </transition>
      </div>
      <div
        :class="
          `filter-pill ${!locationPicker && !selectedLocation ? 'not-set' : ''}`
        "
        ref="locationDropdown"
      >
        <button
          @click="() => handlePickerToggle('location')"
          class="filter-button"
        >
          <span class="label">
            {{ selectedLocation ? selectedLocation.label : "Location" }}
          </span>
          <span
            v-if="selectedLocation && windowWidth >= 640"
            @click.stop="
              () => {
                selectedLocation = null;
                tempLocation = null;
                locationPicker - false;
              }
            "
          >
            <icon-base style="height: 1rem; width: 1rem; pointer-events: none;">
              <IconCancel />
            </icon-base>
          </span>
        </button>
        <div
          class="pill-backdrop"
          v-if="windowWidth < 640 && locationPicker"
        ></div>
        <transition name="fade-up">
          <div v-if="locationPicker" class="pill-dropdown">
            <div class="pill-header" v-if="windowWidth < 640">
              <h5>Location</h5>
              <button class="dropdown-close" @click="closeDropdowns()">
                <img
                  class="icon-close"
                  src="@/assets/media/icons/icon-close-v2.svg"
                  alt="icon-close"
                />
              </button>
            </div>
            <div
              class="picker-container"
              v-on-clickaway="
                () => {
                  locationPicker = false;
                }
              "
            >
              <ul class="picker-select--list">
                <li
                  v-for="(location, key) in locationOptions"
                  :key="key"
                  :class="[
                    'picker-select--item',
                    {
                      active:
                        selectedLocation &&
                        selectedLocation.value === location.value,
                      disabled: !location.count
                    }
                  ]"
                  @click="
                    () => {
                      tempLocation = location;
                    }
                  "
                >
                  <label
                    class="css-control css-control-primary css-control-lg css-checkbox"
                  >
                    <template v-if="windowWidth < 640">
                      <input
                        type="radio"
                        class="css-control-input"
                        :class="
                          tempLocation && tempLocation.value === location.value
                            ? 'checked'
                            : ''
                        "
                        name="type"
                        :value="
                          tempLocation && tempLocation.value === location.value
                        "
                        checked
                      />
                      <span class="css-control-indicator"></span>
                    </template>
                    <span class="list-text"
                      >{{ location.label }}
                      {{ location.count ? `(${location.count})` : "" }}
                    </span>
                  </label>
                </li>
              </ul>
              <div class="picker-action" v-if="windowWidth < 640">
                <ActionButton
                  class="btn-clear"
                  type="button"
                  :mode="'outline'"
                  :label="null"
                  :theme="buttonTheme"
                  :disabled="!this.tempLocation"
                  @customEvent="applySelected('location', true)"
                >
                  <p>Clear</p>
                </ActionButton>
                <ActionButton
                  class="btn-view"
                  type="button"
                  :label="null"
                  :theme="buttonTheme"
                  :disabled="isDisabledLocation"
                  @customEvent="applySelected('location')"
                >
                  <p>
                    View
                    {{ tempLocation ? `${tempLocation.count}` : "" }} workspaces
                  </p>
                </ActionButton>
              </div>
            </div>
          </div>
        </transition>
      </div>
    </div>
    <hr :style="{ borderColor: '#ddd', paddingBottom: '1rem' }" />
    <div>
      <div class="row" v-if="isAdmin">
        <div class="col mb-2 booking-placeholder">
          Booking on behalf of
          <span v-if="user" :style="{ color: primary }">{{
            `${user.firstName} ${user.lastName}`
          }}</span>
        </div>
        <div class="col text-right">
          <ActionButton
            mode="outline"
            class="w-auto d-inline-block m-0"
            @customEvent="toMember"
            :theme="{ primary, secondary, event, danger }"
            label="Back"
          />
        </div>
      </div>
      <p v-if="filteredProducts.length" class="results-counter">
        Showing
        <span class="number">{{
          filteredProducts.filter(product => product.Terms.length).length
        }}</span>
        result{{ products.length > 1 ? "s" : "" }}
      </p>
    </div>
    <div v-if="isLoading">
      <div class="card-list loading">
        <BookingCardSkeleton v-for="index in 8" :key="index" />
      </div>
    </div>
    <template v-if="filteredProducts.length">
      <div class="card-list">
        <template v-for="product of filteredProducts">
          <BookingCard
            :key="'product-' + product.id"
            :item="product"
            v-if="product.Terms.length"
            @response="onOpenModal"
          />
        </template>
      </div>
    </template>
    <template v-else-if="!isLoading">
      <div class="no-products">
        <lottie-player
          autoplay
          class="placeholder__player"
          src="/lottiefiles/empty-result.json"
          style="max-width: 200px; height: auto; margin: 0 auto;"
        />
        <h5>Oh no! There are no available products matching your search...</h5>
        <p>Please try a different date.</p>
      </div>
    </template>
    <NewModalBooking
      v-if="isModalOpen"
      @close="onCloseModal"
      @submit="onSubmitModal"
      :data="modalData"
    ></NewModalBooking>
  </div>
</template>

<script>
import NewModalBooking from "@/components/booking/NewModalBooking";
import BookingCard from "@/components/booking/shared/BookingCard";
import BookingCardSkeleton from "@/components/booking/shared/BookingCardSkeleton";
import DateTimePickerResponsive from "@/components/datetimepicker/DateTimePickerResponsive";
import axios from "@/helpers/axios";
import { formatSchedule, overlap } from "@/helpers/booking";
import IconCancel from "../icons/IconCancel.vue";
import "@lottiefiles/lottie-player";
import { addDays, addHours, format } from "date-fns";
import { dateUTC } from "@/helpers/date";
import { mapActions, mapGetters } from "vuex";
import { mixin as clickaway } from "vue-clickaway";
import { uniqBy, cloneDeep, orderBy } from "lodash";
import ActionButton from "@/components/ActionButton";

export default {
  name: "NewBooking",
  components: {
    NewModalBooking,
    BookingCard,
    DateTimePickerResponsive,
    IconCancel,
    ActionButton,
    BookingCardSkeleton
  },
  mixins: [clickaway],
  data() {
    return {
      active: -1,
      products: [],
      categories: [],
      locations: [],
      selectedCategory: null,
      tempCategory: null,
      selectedLocation: null,
      tempLocation: null,
      categoryId: this.$route.params.categoryId,
      productId: null,
      locationId: null,
      isModalOpen: false,
      item: null,
      orderData: null,
      orderIndex: null,
      isLoading: true,
      isAdmin: false,
      categoryPicker: false,
      locationPicker: false,
      user: null,
      startDate: null,
      tempStartDate: null,
      appliedStartDate: null,
      appliedEndDate: null,
      timeZone: this.$route.query.timeZone,
      anytime: null,
      dateCleared: false,
      showDateFilter: true,
      windowWidth: window.innerWidth,
      buttonTheme: {
        primary: "#20c997"
      }
    };
  },
  beforeCreate() {
    if (!this.$route.query.startDate || !this.$route.query.timeZone) {
      const newSchedStart = addDays(new Date(), 1).toISOString();
      const formatedDate = format(newSchedStart, "YYYY/MM/DD");

      this.$router.replace({
        name:
          this.$router.currentRoute.name !== "Admin Booking"
            ? "UserBookingV3"
            : "Admin Booking",
        query: {
          startDate: new Date(`${formatedDate} 12:00 AM`).toISOString(),
          timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
          anytime: false
        }
      });
    }
  },
  created() {
    this.startDate = !isNaN(new Date(this.$route.query.startDate).getTime())
      ? this.$route.query.startDate
      : new Date.toISOString();
    this.tempStartDate = !isNaN(new Date(this.$route.query.startDate).getTime())
      ? this.$route.query.startDate
      : new Date.toISOString();

    if (this.$route.query.anytime === "false" || !this.$route.query.anytime) {
      this.anytime = false;
    } else {
      this.anytime = true;
    }
    this.getCollections("categories");
    this.getCollections("locations");
    this.handleReload();
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", () => {
        this.windowWidth = window.innerWidth;
      });
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", () => {
      this.windowWidth = window.innerWidth;
    });
  },
  watch: {
    tempCategory(newVal) {
      if (this.windowWidth < 640) return;
      this.selectedCategory = newVal;
    },
    selectedCategory() {
      this.categoryPicker = false;
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = false;
      }, 300);
    },
    tempLocation(newVal) {
      if (this.windowWidth < 640) return;
      this.selectedLocation = newVal;
    },
    selectedLocation() {
      this.locationPicker = false;
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = false;
      }, 300);
    }
  },
  computed: {
    modalData() {
      return {
        productId: this.productId,
        categoryId: this.categoryId,
        locationId: this.locationId,
        item: this.item
      };
    },
    category() {
      return this.categories.find(item => item.value == this.categoryId);
    },
    primary() {
      return this.$store.state.app.scheme.primary;
    },
    danger() {
      return this.$store.state.app.scheme.primary;
    },
    event() {
      return this.$store.state.app.scheme.event;
    },
    secondary() {
      return this.$store.state.app.scheme.secondary;
    },
    dateFilterOutput() {
      if (this.showDateFilter)
        return this.formatFilterDate(this.startDate, "ddd, MMM DD");

      return "Date";
    },
    filteredProducts() {
      if (!this.selectedCategory && !this.selectedLocation)
        return this.products;
      return this.products.filter(pr => {
        if (this.selectedCategory && this.selectedLocation) {
          return (
            this.selectedCategory.value === pr.categoryId &&
            this.selectedLocation.value === pr.locationId
          );
        }

        if (this.selectedCategory)
          return this.selectedCategory.value === pr.categoryId;

        if (this.selectedLocation)
          return this.selectedLocation.value === pr.locationId;
      });
    },
    categoryOptions() {
      const products = this.selectedLocation
        ? this.products.filter(
            pr => pr.locationId === this.selectedLocation.value
          )
        : this.products;

      if (this.products.length === 0) return this.categories;

      return this.categories.map(item => {
        const count = products.filter(p => p.categoryId === item.value).length;
        item.count = count;
        return item;
      });
    },
    locationOptions() {
      const products = this.selectedCategory
        ? this.products.filter(
            pr => pr.categoryId === this.selectedCategory.value
          )
        : this.products;
      if (this.products.length === 0) return this.locations;

      return this.locations.map(item => {
        const count = products.filter(p => p.locationId === item.value).length;
        item.count = count;
        return item;
      });
    },
    isDisabledCategory() {
      if (!this.tempCategory) return true;
      return (
        this.tempCategory &&
        this.selectedCategory &&
        this.tempCategory.value === this.selectedCategory.value
      );
    },
    isDisabledLocation() {
      if (!this.tempLocation) return true;
      return (
        this.tempLocation &&
        this.selectedLocation &&
        this.tempLocation.value === this.selectedLocation.value
      );
    }
  },
  methods: {
    ...mapActions({
      ORDER_ADD_SCHEDULE: "ORDER_ADD_SCHEDULE"
    }),
    ...mapGetters({
      orders: "getOrders"
    }),
    async init() {
      let action = `qp[start]=${dateUTC(
        this.appliedStartDate
      )}&qp[end]=${dateUTC(this.appliedEndDate)}&qp[quantity]=1&timeZone=${
        this.timeZone
      }&anytime=${this.anytime}&anydate=${!this.showDateFilter}`;
      await this.paginated("products/available", action);

      if (this.$route.matched[0].name == "admin") {
        this.isAdmin = true;
        let userId = this.$route.params.id;
        axios.get(`/users/${userId}`).then(response => {
          this.user = response.data.data;
        });
      }
    },
    handleReload() {
      this.products = [];
      const appliedDate = this.dateCleared
        ? this.formatFilterDate(new Date(), "YYYY/MM/DD")
        : this.formatFilterDate(new Date(this.startDate), "YYYY/MM/DD");

      this.appliedStartDate = new Date(`${appliedDate} 12:00 AM`).toISOString();
      this.appliedEndDate = new Date(`${appliedDate} 11:59 PM`).toISOString();

      this.$router.push({
        query: {
          startDate: this.appliedStartDate,
          timeZone: this.timeZone,
          anytime: this.anytime,
          anydate: !this.showDateFilter,
          t: new Date().toISOString()
        }
      });
      this.isLoading = true;
      this.init();
    },
    closeDropdowns() {
      this.categoryPicker = false;
      this.locationPicker = false;

      if (this.windowWidth < 640) {
        if (!this.selectedCategory && this.tempCategory)
          this.tempCategory = null;
        if (!this.selectedLocation && this.tempLocation)
          this.tempLocation = null;
      }
    },
    handleDateClear() {
      const newSchedStart = addDays(new Date(), 1).toISOString();
      const formatDate = format(newSchedStart, "YYYY/MM/DD");
      this.startDate = new Date(`${formatDate} 12:00 AM`).toISOString();

      this.dateCleared = true;
      this.showDateFilter = false;
      if (this.dateCleared) {
        if (this.windowWidth >= 640) this.$refs.startDate.handleDismiss();
        this.handleReload();
      }
    },
    applyFilters() {
      this.showDateFilter = true;
      const appliedDate = this.dateCleared
        ? this.formatFilterDate(new Date(), "YYYY/MM/DD")
        : this.formatFilterDate(new Date(this.startDate), "YYYY/MM/DD");

      this.appliedStartDate = new Date(`${appliedDate} 12:00 AM`).toISOString();
      this.appliedEndDate = new Date(`${appliedDate} 11:59 PM`).toISOString();

      this.tempStartDate = this.startDate;
      this.handleReload();
    },
    handleClose() {
      this.startDate = this.tempStartDate;
    },
    applySelected(filterKey, isClear = false) {
      switch (filterKey) {
        case "category":
          this.selectedCategory = isClear ? null : this.tempCategory;
          if (isClear) this.tempCategory = null;
          if (this.locationOptions.length === 1)
            this.selectedLocation = this.locationOptions.find(v => v.value);
          this.categoryPicker = false;
          break;
        case "location":
          this.selectedLocation = isClear ? null : this.tempLocation;
          if (isClear) this.tempLocation = null;
          if (this.categoryOptions.length === 1)
            this.selectedCategory = this.categoryOptions.find(v => v.value);
          this.locationPicker = false;
          break;
        default:
          break;
      }
    },
    handleDisabledDate(date) {
      return (
        date.getTime() < new Date().getTime() &&
        date.toLocaleDateString() !== new Date().toLocaleDateString()
      );
    },
    handlePickerToggle(filterName) {
      switch (filterName) {
        case "category":
          if (this.categoryOptions.length) {
            this.locationPicker = false;
            this.categoryPicker = !this.categoryPicker;
          }
          break;
        case "location":
          if (this.locationOptions.length) {
            this.categoryPicker = false;
            this.locationPicker = !this.locationPicker;
          }
          break;
        default:
          break;
      }
    },
    formatFilterDate(date, pattern = "ddd MMM D, YYYY") {
      return format(new Date(date), pattern);
    },
    formatTime(date) {
      return format(new Date(date), "h:mm A");
    },
    formatDate(date, pattern = "MMM DD, YYYY h:mm A") {
      return format(new Date(date), pattern);
    },
    // TODO: Refactor method to be reusable.
    paginated(collection, action = "", page = 1) {
      const onCart = JSON.parse(JSON.stringify(this.orders())).map(
        order => order
      );
      return axios
        .get(
          `/${collection}?page[number]=${page}&page[size]=99999&${action}&status=2`
        )
        .then(response => {
          let { data, meta } = response.data;
          data = data.map(product => ({
            ...product,
            label: product.name,
            image: product.image,
            id: product.id,
            locationId: product.locationId,
            location: product.Location,
            // TODO: Additional capacity from source
            category: this.category,
            Terms: this.sortTerm(product.Terms)
          }));

          const products = data.filter(
            p => !this.validateProductsFromCart(p, onCart)
          );

          this["products"] = uniqBy([...this["products"], ...products], "id");
          if (meta.hasNextPage) {
            this.paginated(collection, action, page + 1);
          }
        })
        .finally(() => (this.isLoading = false));
    },
    sortTerm(terms) {
      const termKeys = ["hour", "day", "week", "month", "year"];
      const sortedTerms = [];
      termKeys.forEach(tKey => {
        sortedTerms.push(
          ...terms
            .filter(t => t.calculatedBy === tKey)
            .sort((a, b) => a.calculatedValue - b.calculatedValue)
        );
      });
      return sortedTerms;
    },
    onOpenModal(payload) {
      document.body.style.overflow = "hidden";
      this.productId = payload.productId;
      this.locationId = payload.locationId;
      this.categoryId = payload.item.Category.id;
      this.item = payload.item;
      this.active = payload.item.id;
      this.isModalOpen = true;
    },
    onCloseModal() {
      document.body.style.overflow = null;
      this.orderData = null;
      this.orderIndex = null;
      this.isModalOpen = false;
    },
    getCollections(collection, action = "", page = 1) {
      return axios
        .get(`/${collection}?page[number]=${page}&page[size]=9999&${action}`)
        .then(response => {
          var { data } = response.data;
          data = data.map(product => ({
            label: product.name,
            value: product.id,
            count: 0
          }));
          this[collection] = uniqBy([...this[collection], ...data], "value");
        });
    },
    validateProductsFromCart(product, onCart) {
      if (!this.showDateFilter) return false;
      const disabledItems = this.handleOrderFromCartDates(
        product.data,
        product
      );
      const timeItems = this.generateAvailableHours(disabledItems);
      const dateString = format(new Date(this.startDate), "YYYY/MM/DD");
      const timeItem = timeItems.find(v => !v.disabled);
      const startTimeItem = timeItem ? timeItem.name : " 11:30 PM ";
      const { calculatedValue } = this.getTerm(product);
      const startAt = new Date(`${dateString} ${startTimeItem}`);
      const endAt = addHours(startAt, calculatedValue);

      const linkedProductsOnCart = onCart.map(orderOnCart => {
        if (product.id === orderOnCart.Product.id) return orderOnCart;
        if (!orderOnCart.Product.ProductLink) return;
        if (
          product.ProductLink &&
          orderOnCart.Product.ProductLink.productCollectionId ===
            product.ProductLink.productCollectionId
        ) {
          orderOnCart.Product.id = product.id;
          return orderOnCart;
        }
      });

      const orderPackage = {
        packageId: null,
        productId: product.id,
        startAt: dateUTC(startAt.toISOString()),
        endAt: dateUTC(endAt.toISOString()),
        quantity: 1,
        itemQuantity: 1,
        total: 0
      };

      const newLinkedBooking = [
        { OrderPackage: orderPackage, Product: { id: product.id } }
      ];
      const overlapResult = overlap(
        linkedProductsOnCart,
        newLinkedBooking,
        product.id,
        this.orderIndex
      );

      return overlapResult.overlap;
    },
    handleOrderFromCartDates(disabledItems, product) {
      const cartItems = JSON.parse(JSON.stringify(this.orders()));
      const orderQuantity = 1;
      const timeItems = this.generateAvailableHours(disabledItems);
      const st = format(new Date(this.startDate), "MMMM DD, YYYY");
      let clonedDisabledItems = cloneDeep(disabledItems);

      cartItems.forEach(cartItem => {
        const itemQuantity =
          cartItem.OrderPackage.itemQuantity >= 0
            ? cartItem.OrderPackage.itemQuantity
            : 1;
        const validateLimited =
          product.quantity >= 0 ? orderQuantity >= itemQuantity : true;
        const hasProduct = product.productLinkCollection
          ? product.productLinkCollection.find(
              v => v.productId === cartItem.OrderPackage.productId
            )
          : product.id === cartItem.OrderPackage.productId;
        if (
          cartItem.OrderPackage &&
          (cartItem.OrderPackage.productId === product.id || hasProduct) &&
          validateLimited
        ) {
          const cartItemSched = formatSchedule(cartItem.OrderPackage);
          const { startDate, startTime, endDate, endTime } = cartItemSched;

          if (startDate === st) {
            timeItems.forEach(st => {
              if (
                parseInt(st.value) >= parseInt(startTime) &&
                parseInt(st.value) < parseInt(endTime)
              ) {
                clonedDisabledItems.push(st.value);
              }
            });
          }

          if (st === endDate) {
            timeItems.forEach(st => {
              if (
                parseInt(st.value) >= parseInt(startTime) &&
                parseInt(st.value) < parseInt(endTime)
              ) {
                clonedDisabledItems.push(st.value);
              }
            });
          }
        }
      });
      return orderBy(clonedDisabledItems, n => parseInt(n), ["asc"]);
    },
    generateAvailableHours(disabledItems) {
      return Array.apply(null, { length: 49 }).map((time, index) => {
        const disabled = disabledItems.includes(index.toString());

        return {
          value: index.toString(),
          name: format(new Date(0, 0, 0, 0, index * 30), "hh:mm A"),
          disabled: disabled
        };
      });
    },
    getTerm(product) {
      const terms = product.Terms ? product.Terms : [];
      const term = terms
        .filter(t => t.calculatedBy === "hour")
        .sort((a, b) => a.calculatedValue - b.calculatedValue)
        .find(t => t.calculatedValue);

      return {
        calculatedBy: term ? term.calculatedBy : "hour",
        calculatedValue: term ? term.calculatedValue : 23
      };
    },
    onSubmitModal(schedule) {
      const currentModule = this.$route.matched[0].name;
      if (["admin", "user"].includes(currentModule)) {
        this.ORDER_ADD_SCHEDULE(schedule);
      }
      this.onCloseModal();
      switch (currentModule) {
        case "user":
          this.$router.push({ name: "UserCheckout" });
          break;
        case "admin":
          this.$router.push({
            name: "admin-checkout",
            params: { id: this.$route.params.id }
          });
          break;
        default:
      }
    },
    toMember() {
      this.$router.push("/admin/members");
    },
    handleDateChange(selectedDate) {
      if (this.windowWidth >= 640 && !this.dateCleared) {
        if (
          selectedDate.toISOString() === this.appliedStartDate &&
          this.showDateFilter
        ) {
          this.$refs.startDate.handleDismiss();
          return;
        }
        this.applyFilters();
        this.$refs.startDate.handleDismiss();
      }
      this.dateCleared = false;
    }
  }
};
</script>

<style lang="scss">
.container.new-booking-container {
  max-width: 1340px;
  h2 {
    font-size: $font-size-xl;
  }

  .no-products {
    min-height: calc(100vh - 116px);
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 3rem;

    h5 {
      font-size: 1.25rem;
      line-height: 1.75rem;
      text-align: center;
      max-width: 400px;
      padding-top: 2rem;
      padding-bottom: 0.5rem;
      margin: 0;

      @media screen and (min-width: 640px) {
        padding-bottom: 1rem;
      }
    }

    p {
      text-align: center;
    }
  }

  .close-picker-container {
    position: absolute;
    height: 100vh;
    width: 100vw;
    top: 0;
    left: 0;
  }

  .filters-container {
    display: flex;
    gap: 1rem;

    @media screen and (max-width: 639px) {
      flex-wrap: nowrap;
    }
  }

  .datepicker-close {
    height: 100vh;
    width: 100vw;
    background-color: #fff;
  }

  .filter-pill {
    border-radius: 1.1875rem;
    border: 1px solid $brand-primary-v2;
    background-color: #e6f7f9;
    color: $brand-primary-v2;
    font-size: 0.875rem;
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;

    &.not-set {
      border-color: #4c4c4c;
      background-color: #fff;
      color: #4c4c4c;
    }

    &:not(:first-child) {
      flex: 0 1 auto;

      @media screen and (max-width: 639px) {
        overflow: hidden;
        max-width: 140px;
      }
    }

    .datepickers {
      padding: 8px 16px;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      width: max-content;

      &.empty {
        width: unset;
        .dt-output {
          color: #4c4c4c;
        }
      }

      .form-group {
        margin: 0;
      }

      .icon-clear {
        margin-left: 8px;
      }

      .dt-output {
        border: none;
        padding: 0;
        color: $brand-primary-v2;
        font-size: 0.875rem;
        white-space: unset;
      }

      .datepicker {
        .calendar-month-select,
        .calendar-year-select {
          color: #4c4c4c;
        }
      }
    }
  }

  .filter-button {
    all: unset;
    padding: 0.5rem 1rem;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 0.5rem;
    overflow: hidden;

    &:hover {
      cursor: pointer;
    }

    .label {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .pill-backdrop {
    position: fixed;
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    background-color: #ffffff;
    top: 0;
    left: 0;
    z-index: 1009;
  }

  .pill-header {
    width: 100%;
    height: 56px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 24px;

    .dropdown-close {
      cursor: pointer;
      border: none;
      background-color: transparent;
      padding: 0 6px;
      margin-right: 4px;

      .icon-close {
        width: 1.2rem;
      }
    }

    h5 {
      font-family: "Metropolis";
      font-weight: 600;
      font-size: 18px;
      line-height: 26px;
      color: #232323;
      margin: 0;
    }
  }

  .pill-dropdown {
    position: fixed;
    display: flex;
    flex-direction: column;
    box-shadow: 0px 2px 8px #00000014;
    border-radius: 0.5rem;
    padding: 1rem;
    background-color: white;
    left: 0;
    top: 0;
    z-index: 1010;
    width: 100%;
    height: 100%;

    @media screen and (min-width: 640px) {
      position: absolute;
      width: 240px;
      height: unset;
      top: 115%;
      z-index: 20;
    }
  }

  .picker-container {
    display: flex;
    height: calc(100% - 42px);
    flex-direction: column;
    position: relative;

    .time__label,
    .form-label {
      color: #4c4c4c;
    }

    .time__input {
      button {
        border-color: #ccc !important;
        color: #4c4c4c !important;
        height: 2.5rem;
        width: 7.5rem;
        margin-right: 0px !important;
        text-align: left;

        &:hover {
          border-color: $brand-primary-v2 !important;
          background-color: transparent !important;
        }
      }
    }

    .pickers {
      width: 10rem;
    }
  }

  .picker-action {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    border-top: 1px solid #dddddd;
    padding: 16px;
    width: 100vw;
    left: -16px;
    bottom: 0;
    position: absolute;

    button {
      width: min-content;
      padding: 10px 16px;
      margin: 0;
      p {
        margin: 0;
      }
    }

    .btn-clear {
      border: none;

      &:disabled {
        background-color: transparent !important;

        p {
          color: #b7b7b7;
        }
      }
    }
  }

  .picker-button {
    all: unset;
    color: $brand-primary-v2;

    &:hover {
      cursor: pointer;
      text-decoration: underline;
    }

    &.clear-disabled {
      pointer-events: none;
      color: #b7b7b7;
    }
  }
  .results-counter {
    color: #4c4c4c;
    font-size: 0.875rem;

    .number {
      font-weight: 600;
    }
  }

  .picker-select {
    &--list {
      padding: 0;
      list-style: none;
      width: 100%;
      margin-bottom: 0;
      height: calc(100% - 80px);
      overflow: auto;
    }

    &--item {
      margin-bottom: 12px;
      display: flex;
      flex-direction: row;
      width: 100%;
      cursor: pointer;

      &:hover {
        background-color: #e7f9fc;
      }

      &:last-child {
        margin-bottom: 0;
      }

      &.active {
        .list-text {
          color: #4c4c4c;
        }

        @media screen and (min-width: 640px) {
          .list-text {
            color: $brand-primary-v2;
          }
        }
      }

      &.disabled {
        background-color: transparent;
        cursor: default;
        pointer-events: none;

        .css-control {
          cursor: default;
        }

        .list-text {
          color: #b7b7b7;
        }
      }

      .list-text {
        color: #4c4c4c;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
      }

      .css-control {
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 0;
        cursor: pointer;
      }

      .css-control-indicator {
        margin-right: 8px;
        width: 20px;
        height: 20px;
        background-color: #fff;
        border: 1px solid #ddd;
        border-radius: 50%;

        &::after {
          content: "";
        }
      }
    }
  }

  .card {
    &-list {
      &.loading {
        padding-top: 2.8994rem;
      }
      display: flex;
      flex-flow: row wrap;
      margin-left: -15px;
      margin-right: -15px;
    }
  }
  .booking-placeholder {
    font-family: "Gotham Book";
    font-size: 0.8rem;
  }

  .fade-up-enter-active {
    animation: fade-up-down 0.2s;
  }

  .fade-up-leave-active {
    animation: fade-up-down 0.2s reverse;
  }

  @keyframes fade-up-down {
    0% {
      opacity: 0;
      transform: translateY(0.5rem);
    }
    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }
}
</style>
